var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRainyThunder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2498 23.9645L22.2799 21.2748C22.5542 21.0917 22.8801 21.4209 22.6943 21.6934L20.87 24.3671C20.7986 24.4718 20.8006 24.6101 20.8751 24.7126L21.9898 26.2466C22.0897 26.3841 22.0556 26.577 21.9146 26.6719L18.3723 29.0546C18.0981 29.2391 17.7708 28.9096 17.957 28.6366L19.4997 26.3755C19.5743 26.2663 19.5685 26.1211 19.4855 26.0181L18.1828 24.4024C18.0721 24.2651 18.1031 24.0624 18.2498 23.9645Z",
    fill: "#FFDA57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 23L8 26",
    stroke: "#55B1FF",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 23L11 28",
    stroke: "#55B1FF",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 8.285C17.5583 5.26625 15.0333 3 12 3C9.59167 3 7.5 4.435 6.45833 6.535C3.95 6.815 2 9.04625 2 11.75C2 14.6462 4.24167 17 7 17H17.8333C20.1333 17 22 15.04 22 12.625C22 10.315 20.2917 8.4425 18.125 8.285Z",
    fill: "#E1ECF7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3188 13.285C25.7804 10.2662 23.3817 8 20.5 8C18.2121 8 16.225 9.435 15.2354 11.535C12.8525 11.815 11 14.0463 11 16.75C11 19.6462 13.1296 22 15.75 22H26.0417C28.2267 22 30 20.04 30 17.625C30 15.315 28.3771 13.4425 26.3188 13.285Z",
    fill: "#4A4A4A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRainyThunder);
export default __webpack_public_path__ + "static/media/icon-rainy-thunder.8b72a34fa6417e681844f7c454fd8666.svg";
export { ForwardRef as ReactComponent };